import { axiosPublic } from '../api/connector'

const resendConfirmationEmail = (values: any) => {
    return axiosPublic.post('/v1/auth/resend-confirmation-email/', values)
}

export const emailsService = {
    resendConfirmationEmail,
}
